// ═══ SHARED CONSTANTS & HELPERS ═══

export const ISSUES = [
  'Owner Name Incorrect',
  'Vendor Changed / New Owner',
  'Bank Account No. Wrong',
  'IFSC Code Wrong',
  'Bank Name Mismatch',
  'PAN Number Wrong',
  'Rent Amount Incorrect',
  'Godown Not In Use / Vacated',
  'Godown Address Changed',
  'Other',
];

export const MONTHS = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];

export function getCurrentPayMonth() {
  const d = new Date();
  return `${MONTHS[d.getMonth()]}-${d.getFullYear()}`;
}

export function monthToNum(mk) {
  if (!mk) return 0;
  const parts = mk.split('-');
  const idx = MONTHS.indexOf(parts[0]);
  if (idx === -1) return 0;
  return parseInt(parts[1]) * 100 + (idx + 1);
}

export function shiftMonth(mk, n) {
  const parts = String(mk || '').split('-');
  const idx = MONTHS.indexOf(parts[0]);
  if (idx === -1) return mk;
  const total = parseInt(parts[1], 10) * 12 + idx + n;
  return `${MONTHS[((total % 12) + 12) % 12]}-${Math.floor(total / 12)}`;
}

// The month the rent is FOR, given the month it is paid in.
// Prepaid (Adv) pays the current month in advance; postpaid (Cur) settles the
// month just gone. Pay month Sep-2026 -> Adv: Sep-2026, Cur: Aug-2026.
export function getRentMonth(payMonth, payNature) {
  return payNature === 'Adv' ? payMonth : shiftMonth(payMonth, -1);
}

// Year choices for the Rent Starting Period picker: five back, one forward.
export function getPeriodYears() {
  const y = new Date().getFullYear();
  const years = [];
  for (let i = y - 5; i <= y + 1; i++) years.push(i);
  return years;
}

export function fmt(n) {
  return Number(n || 0).toLocaleString('en-IN');
}

export function getFYMonths() {
  const d = new Date();
  const yr = d.getFullYear();
  const mo = d.getMonth();
  const startYr = mo >= 3 ? yr : yr - 1;
  const months = [];
  for (let i = 0; i < 12; i++) {
    const m = (3 + i) % 12;
    const y = m < 3 ? startYr + 1 : startYr;
    months.push({ key: `${MONTHS[m]}-${y}`, label: `${MONTHS[m]} ${y}` });
  }
  return months;
}

export function getSimulatorMonths() {
  const months = [];
  const seen = {};
  for (let i = -3; i <= 15; i++) {
    const d = new Date();
    d.setMonth(d.getMonth() + i);
    const key = `${MONTHS[d.getMonth()]}-${d.getFullYear()}`;
    if (!seen[key]) {
      seen[key] = true;
      months.push({ key, label: `${MONTHS[d.getMonth()]} ${d.getFullYear()}`, sort: d.getFullYear() * 100 + d.getMonth() });
    }
  }
  return months.sort((a, b) => a.sort - b.sort);
}

export function statusBadge(st) {
  const map = {
    yes: { label: 'YES', cls: 'badge-yes' },
    no: { label: 'NO', cls: 'badge-no' },
    expired: { label: 'EXPIRED', cls: 'badge-expired' },
    pending: { label: 'PENDING', cls: 'badge-pending' },
  };
  const m = map[st] || map.pending;
  return <span className={`status-badge ${m.cls}`}>{m.label}</span>;
}
